import {setDateTimeConfig} from './utils/app/dateTime';

export const CONFIG = {
  CDA_ORIGIN_URL: '',
  GMA_ORIGIN_URL: '',
  GMA_HEADERS: {},
  CDA_HEADERS: {},
  SOLR_ORIGIN_URL: '',
  SOLR_API_KEY: '',
  BRAND: '',
  CHANNEL: '',
  COUNTRY: '',
  GBO_TIME_FORMAT: 'YYYY-MM-DDTHH:mm',
  DYNAMIC_CONTENT_ORIGIN_URL: "",
  DATE_TIME_FORMAT: {},
  ERROR_DEFAULT: 'We\'re sorry. Please try again later.',
  ERROR_STATUS: {},
  STATUS_I18N_CODE: false,
  LANGUAGE: '',
  LOCALE: '',
  SOLR_DTO: false,
  RECAPTCHA_SITE_KEY: ''
};

/**
 * @name setAppConfig
 * @desc Independent export for setting gmi config, to be used when not using initGmi, such as in tests.
 * @description Independent export for setting gmi config, to be used when not using initGmi, such as in tests.
 * @param {Object} obj
 * @example
 * // Configs for GMA, Solr, and ultimately GBO endpoints, along with  necessary headers and query params to make those API calls.
 * const config = {
 *  CDA_ORIGIN_URL, // *(String)*: i.e. https://int1-webapi.natcar-np.com/cda-national/
 *  GMA_ORIGIN_URL, // *(String)*: i.e. https://int1-webapi.natcar-np.com/gma-national/
 *  GMA_HEADERS, // *(Object)*: App specific custom headers to send in GMA requests
 *  CDA_HEADERS, // *(Object)*: App specific custom headers to send in CDA requests
 *  SOLR_ORIGIN_URL, // *(String)*: i.e. https://int1.location.enterprise.com/enterprise-sls/search/location/
 *  DYNAMIC_CONTENT_ORIGIN_URL, // *(String)*: i.e. https://int1-webapi.natcar-np.com/gma-national/
 *  SOLR_API_KEY, // *(String)*: API Key required for SOLR URL
 *  BRAND, // *(String)*: i.e. ALAMO, NATIONAL, or ENTERPRISE
 *  CHANNEL, // *(String)*: i.e. APP or WEB
 *  COUNTRY, // *(String)*: Two letter country code; i.e. US, IE, etc.
 *  DATE_TIME_FORMAT, // *(Object)*: MomentJS formats
 *  GBO_TIME_FORMAT, // *(String)*: 'YYYY-MM-DDTHH:mm', // timestamp format expected by GBO
 *  ERROR_DEFAULT, // *(String)*: i.e. "We're sorry. Please try again later.",
 *  ERROR_STATUS, {}, // *(Object)*: Optional. i.e. {404: 'Page not found.'}
 *  STATUS_I18N_CODE, // *(Boolean)*: Optional. defaults to false. Use translated errors for GMA errors
 *  LANGUAGE, // *(String)*: Two letter language code; i.e. en, es
 *  LOCALE // *(String)*: Language and country code; i.e. en_US, es_ES
 *  SOLR_DTO // *(Boolean)*: Optional. Used to enable SOLR DTO flag
 * }
 * setAppConfig(config)
 */
export function setAppConfig(obj) {
  if (typeof obj === 'object' && obj !== null) {
    Object.assign(CONFIG, obj);
    setDateTimeConfig();
  }
}
